let language = {

    BULK_ORDER_STEP_SHIPPING_SHIPPING_ADDRESS: "收货地址:",
    BULK_ORDER_STEP_SHIPPING_CHANGE_ADDRESS: "更改地址",
    BULK_ORDER_STEP_SHIPPING_BILLING_ADDRESS: "账单地址:",
    BULK_ORDER_STEP_SHIPPING_SHIPPING_METHOD: "配送方式:",
    BULK_ORDER_STEP_SHIPPING_CHANGE_SHIPPING: "更改配送",
    BULK_ORDER_STEP_SHIPPING_ESTIMATED_DELIVERY_TIME_TITLE: "预计交货时间:",
    BULK_ORDER_STEP_SHIPPING_ESTIMATED_DELIVERY_TIME_CONTENT: `
        生产时间 {{productionMinDay}} - {{productionMaxDay}} 个工作日 + 运输时间 {{deliveryMinDay}} - {{deliveryMaxDay}} 个工作日。
    `,
    BULK_ORDER_STEP_SHIPPING_ESTIMATED_RECEIPT_TIME_TITLE: "预计收到时间:",
    BULK_ORDER_STEP_SHIPPING_ADD_REMARK: "添加备注",
    BULK_ORDER_STEP_SHIPPING_EDIT_REMARK: "编辑备注",

    BULK_ORDER_STEP_SHIPPING_PRICE: "价格:",
    BULK_ORDER_STEP_SHIPPING_WEIGHT: "重量:",
    BULK_ORDER_STEP_SHIPPING_TOTAL_PRICE: "总价格:",
    BULK_ORDER_STEP_SHIPPING_TOTAL_WEIGHT: "总重量:",
    BULK_ORDER_STEP_SHIPPING_TAX: "税费:",
    BULK_ORDER_STEP_SHIPPING_SHIPPING_PRICE: "运费:",
    BULK_ORDER_STEP_SHIPPING_PRODUCT_PRICE: "产品费用:",
    BULK_ORDER_STEP_SHIPPING_IMPORT_SERVICE_FEE: "进口服务费:",
    BULK_ORDER_STEP_SHIPPING_TOTAL_DUE: "应付总额:",

    BULK_ORDER_STEP_SHIPPING_ORDER_TOTAL_TAX: "订单税费:",
    BULK_ORDER_STEP_SHIPPING_ORDER_TOTAL_SHIPPING: "订单运费:",
    BULK_ORDER_STEP_SHIPPING_ORDER_TOTAL_IMPORT_SERVICE_FEE: "订单进口服务费:",
    BULK_ORDER_STEP_SHIPPING_ORDER_TOTAL_PRICE: "订单总价:",
     BULK_ORDER_STEP_SHIPPING_ORDER_TOTAL_PRODUCT_PRICE: "订单产品费用:",

    BULK_ORDER_STEP_NONE_CONTENT: "无"

};

export { language }
